import React, { useState, useEffect } from 'react';
import './App.css';

// Theme Provider
import { ThemeProvider } from './contexts/ThemeContext';
import { PortfolioProvider } from './contexts/PortfolioContext';

// Components
import Navigation from './components/Navigation';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Skills from './components/sections/Skills';
import Projects from './components/sections/Projects';
import Contact from './components/sections/Contact';
import ExperienceAndEducation from './components/sections/Experience';
import Explorations from './components/sections/Explorations';
import Beyond from './components/sections/Beyond';

function App() {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'projects', 'skills', 'explorations', 'experience', 'beyond', 'contact'];
      const scrollPosition = window.scrollY + 120; // Account for the fixed navigation

      // A fresh visit or any position near the top always belongs to Home.
      if (window.scrollY < 80) {
        setActiveSection('home');
        return;
      }

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    const initialCheck = window.requestAnimationFrame(handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      window.cancelAnimationFrame(initialCheck);
    };
  }, []);

  return (
    <ThemeProvider>
     <PortfolioProvider>
        <div className="App min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
          <a className="skip-link" href="#main-content">Skip to content</a>
          <Navigation activeSection={activeSection} />
          
          <main id="main-content">
            <Hero />
            <About />
            <Projects />
            <Skills />
            <Explorations />
            <ExperienceAndEducation />
            <Beyond />
            <Contact />
          </main>

          {/* Footer */}
          <footer className="site-footer text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="footer-content">
                <div className="footer-intro">
                  <p className="footer-brand">Sachin Saini<span>.</span></p>
                  <p>Builder and problem solver creating dependable systems, intelligent products, and technology with meaningful impact.</p>
                </div>
                <div className="footer-center">
                  <p className="footer-focus">Open to meaningful conversations</p>
                  <p className="footer-location">Bengaluru, India · Working globally</p>
                  <div className="footer-links">
                    <button onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}>About</button>
                    <button onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}>Projects</button>
                    <button onClick={() => document.getElementById('explorations')?.scrollIntoView({ behavior: 'smooth' })}>Explorations</button>
                  </div>
                </div>
                <div className="footer-meta">
                  <a href="mailto:sachinyashpalsinghsaini@gmail.com">sachinyashpalsinghsaini@gmail.com</a>
                  <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>Let’s connect ↗</button>
                  <span>© {new Date().getFullYear()}</span>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </PortfolioProvider>
    </ThemeProvider>
  );
}

export default App;
